export class DixperInteractor {
  status = DIXPER_DISCONNECTED;
  listener;
  ws;
  promises = [];

  constructor(statusListener) {
    this.listener = statusListener;
  }

  ports = [];
  hosts = ['ws://localhost:5821/'];
  currentHostIndex = 0;

  connect() {
    if (this.status === DIXPER_DISCONNECTED) {
      this.currentHostIndex = 0;
    }
    if (
      this.status !== DIXPER_CONNECTING &&
      this.status !== DIXPER_RECONNECTING
    ) {
      this.updateStatus(DIXPER_CONNECTING);
    }
    this.ws = new WebSocket(this.hosts[this.currentHostIndex]);
    this.ws.onmessage = this.handleWebsocketMessage;
    this.ws.onopen = this.handleWebsocketOpen;
    this.ws.onclose = this.handleWebsocketClose;
  }

  isConnected() {
    return this.status === DIXPER_CONNECTED;
  }

  isConnecting() {
    return this.status === DIXPER_CONNECTING;
  }

  getSkills() {
    return this.sendMessage(GetSkillList);
  }

  launchSkill(skill) {
    let msg = {
      request: {
        action: 'LAUNCH_SKILL',
        payload: skill,
      },
      response: null,
    };
    this.sendMessage(msg);
  }

  handleWebsocketMessage = (message) => {
    const parsed = JSON.parse(message.data);
    if (parsed.action) {
      let promise = this.promises.find((p) => p.action === parsed.action);
      if (promise) {
        if (parsed.payload) {
          promise.resolve(parsed.payload);
        }
        this.promises = this.promises.filter(
          (p) => p.actionId !== promise.actionId
        );
      }
    }
  };

  handleWebsocketOpen = () => {
    this.updateStatus(DIXPER_CONNECTED);
  };

  handleWebsocketClose = (e) => {
    if (
      this.status === DIXPER_CONNECTED ||
      this.status === DIXPER_RECONNECTING
    ) {
      // reconnecting flow
      this.updateStatus(DIXPER_RECONNECTING);
      if (this.currentHostIndex + 1 < this.hosts.length) {
        this.currentHostIndex = this.currentHostIndex + 1;
        this.connect();
      } else {
        this.currentHostIndex = 0;
        this.connect();
      }
    }
    if (this.status === DIXPER_CONNECTING) {
      //connecting flow
      if (this.currentHostIndex + 1 < this.hosts.length) {
        this.currentHostIndex = this.currentHostIndex + 1;
        this.connect();
      } else {
        this.updateStatus(DIXPER_FAILED);
      }
    }
    if (this.status === DIXPER_CONNECTED) {
      this.currentHostIndex = 0;
      this.connect();
    }
  };

  sendMessage = (message) => {
    let {request, response} = message;
    let promiseResolve, promiseReject;

    let promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    let promiseElement = {
      action: response,
      resolve: promiseResolve,
      reject: promiseReject,
    };
    if (response) {
      this.promises.push(promiseElement);
    }

    this.resolve = promiseResolve;
    this.ws.send(JSON.stringify(request));
    return promise;
  };

  disconnect() {
    this.updateStatus(DIXPER_DISCONNECTED);
    this.ws.close();
  }

  updateStatus(newStatus) {
    this.status = newStatus;
    if (this.listener != null) {
      this.listener(newStatus);
    }
  }
}

const GetSkillList = {
  request: {
    action: 'GET_SKILL_LIST',
  },
  response: 'ON_SKILL_LIST',
};

export const DIXPER_CONNECTED = 'DIXPER_CONNECTED';
export const DIXPER_DISCONNECTED = 'DIXPER_DISCONNECTED';
export const DIXPER_CONNECTING = 'DIXPER_CONNECTING';
export const DIXPER_RECONNECTING = 'DIXPER_RECONNECTING';
export const DIXPER_FAILED = 'DIXPER_FAILED';
